import styled from "styled-components";

export const PaddingTop = styled.div`
    padding-top: ${({padding}) => padding}px;
`;